import { useQuery } from '@tanstack/react-query';
import { useAuthentication, usePrefixUrl } from '~/shared/hooks';
import { BackorderList } from 'api-types/src/data-contract/auto-generated/backorder-model';



export const useBackorder = () => {
    const { backorderUrl } = usePrefixUrl()
    const { isAuthenticated, session } = useAuthentication();


    const { data } = useQuery({
        queryKey: ['backorderList'],
        queryFn: async () => {
            const res = await fetch(backorderUrl, {
                headers: {
                    'Authorization': `Bearer ${session?.accessToken}`
                }
            })
            if (res.status === 204) {
                // Return an empty items array if there is no content
                return { items: [] };
            }

            const json: BackorderList = await res.json();
            return json;

        },
        enabled: isAuthenticated,
        refetchOnWindowFocus: true,
    })


    return {
        data,
    }
}
